import { useDataFileStore } from "@/stores/getDataFile";
import { useEventListStore } from "@/stores/getEventList";
import { storeToRefs } from "pinia";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "homePage",
      component: () => import("@/views/homeView.vue"),
    },
    {
      path: "/stations",
      name: "stationPage",
      component: () => import("@/views/stationsView.vue"),
    },
    {
      path: "/realtime",
      name: "displayPage",
      component: () => import("@/views/realtimeView.vue"),
    },
    {
      path: "/database",
      name: "dataSearchPage",
      component: () => import("@/views/dataSearchView.vue"),
    },
    {
      path: "/database/download",
      name: "dataDownloadPage",
      component: () => import("@/views/dataDownloadView.vue"),
    },
    // for tesis
    {
      path: "/database/download/:event",
      name: "dataDownloadPage_event",
      beforeEnter: async (to, from, next) => {
        const eventListStore = useEventListStore();
        const dataFileStore = useDataFileStore();
        const { eventTarget, searchListIdx } = storeToRefs(dataFileStore);
        // console.log(dataFileStore);

        let eventStr = <string>to.params.event,
          dateTime = (function () {
            let year = eventStr.substring(0, 4),
              month = eventStr.substring(4, 6),
              day = eventStr.substring(6, 8),
              hour = eventStr.substring(8, 10),
              min = eventStr.substring(10, 12),
              second = eventStr.substring(12, 14);
            return `${year}-${month}-${day}T${hour}:${min}:${second}`;
          })();

        // console.debug(dateTime);
        await eventListStore.getEventList({ dateTime });
        let event = eventListStore.eventList[0];
        // console.debug(event);
        eventTarget.value = [event];
        searchListIdx.value = 0;

        eventListStore.resetState();
        next();
      },
      component: () => import("@/views/dataDownloadView.vue"),
    },
    {
      path: "/publications/:page",
      name: "publicationsPage",
      component: () => import("@/views/publicationsView.vue"),
    },
    {
      path: "/help",
      name: "helpPage",
      component: () => import("@/views/helpPageView.vue"),
    },
    {
      // 亂打網址會被指回首頁
      path: "/:catchAll(.*)",
      name: "redirect",
      redirect: "/",
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("@/views/adminView.vue"),
      beforeEnter: async (to, from, next) => {
        let getClientIP = () => {
          const url = "https://api.ipify.org?format=json";

          return new Promise((res, rej) =>
            fetch(url)
              .then((response) => response.json())
              .then((data) => {
                // console.log(data);
                res(data.ip);
              })
              .catch((error) => {
                console.log(error);
                rej(error);
              })
          );
        };
        const allowedIPs = ["140.109.80", "140.109.81", "140.109.82"];

        let clientIP = (<string>await getClientIP())
          .split(".")
          .slice(0, 3)
          .join("."); // 獲取客戶端 IP 前三組

        if (allowedIPs.includes(clientIP)) {
          console.log("Access granted for IP:", clientIP);
          next(); // 允許導航
        } else {
          console.warn("Access denied for IP:", clientIP);
          next({ name: "homePage" }); // 導回首頁
        }
      },
    },
    // {
    //   path: "/test",
    //   name: "test",
    //   component: () => import("@/views/_test.vue"),
    // },
  ],
});

// router.beforeEach((to, from, next) => {
//   console.debug("next", next);
//   next();
// });
// console.debug("router", router);
export default router;
